export const emptyPrime =
  [{
    addr: "",
    eligible_time: 0,
    staked: 0
  }];

/* example
{   "addr":"0xc07cdA60F9537a5D468E439551eFA69683bC5588",
    "eligible_time":1702706419,
    "staked":1000}
*/
